import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../shared';


/**
 * Tabset component that handles canvas views.
 */
@Component({
	selector: 'canvas-tabset',
	templateUrl: './canvas-tabset.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class CanvasTabsetComponent extends BaseComponent {
	/**
	* Display AP view.
	*/
	setAPView(): void {
		this.canvasSrv.dispatch('setViewAP');
	}
	/**
	* Display Lateral view.
	*/
	setLTView(): void {
		this.canvasSrv.dispatch('setViewLT');
	}
	/**
	* Display Multiple view.
	*/
	setMTView(): void {
		this.canvasSrv.dispatch('setViewMultiple');
	}
}
